<div class="indicators">
  <div class="indicator-container"
       *ngIf="qualityColor"
       [matTooltip]="tooltipMessage"
       matTooltipPosition="above">

    <div class="quality-dot" [ngClass]="qualityColor"></div>

    <span class="quality-label" [ngClass]="qualityColor">
      {{ qualityLabel }}
    </span>
  </div>

  <div class="indicator-container"
       *ngIf="azimutalEnabled === 0 || azimutalEnabled === 1"
       [matTooltip]="azimutalEnabled === 1 ? 'Pasa azimutal' : 'No pasa azimutal'"
       matTooltipPosition="above">
    <div class="quality-dot" [ngClass]="azimutalEnabled === 1 ? 'VERDE' : 'ROJO'"></div>
    <span class="quality-label" [ngClass]="azimutalEnabled === 1 ? 'VERDE' : 'ROJO'">
      {{ azimutalEnabled === 1 ? 'PASA AZIMUTAL' : 'NO PASA AZIMUTAL' }}
    </span>
  </div>
</div>
